export default "__VITE_ASSET__82ba6a9a__"